import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './message-container.hooks';

@Component({
	selector: 'app-stewart-message-container',
	templateUrl: './message-container.component.html',
	animations: [openClose()],
	standalone: false,
})
export class MessageContainerComponent implements OnInit {
	testHooks = TestHooks;
	public height = '100%';
	public originalHeight: string;
	public minHeight = 25;
	public showAll = true;

	@ViewChild('message') messageContainer: ElementRef;

	@Select(SelectedMatter.titleInsuranceMessages) messages$: string[];

	ngOnInit(): void {
		setTimeout(() => {
			this.originalHeight = this.messageContainer.nativeElement.offsetHeight;
			this.height = `${this.minHeight}px`;
			this.showAll = Number(this.originalHeight) <= this.minHeight;
		}, 5000);
	}

	clickShowAll() {
		this.showAll = true;
		this.height = '100%';
	}
}
